import { RecentlyPlayedGame } from '../../communication/player-account/PlayerAccountApi'
import { PlayerItemAction, RecentlyPlayedActionTypes } from './RecentlyPlayedActions'

export interface RecentlyPlayedState {
	recentlyPlayedGameItems: RecentlyPlayedGame[];
	error: Error;
}

const initialState: RecentlyPlayedState = {
	recentlyPlayedGameItems: [],
	error: null,
}

export const recentlyPlayedReducer = (
	state: RecentlyPlayedState = initialState,
	action: PlayerItemAction
): RecentlyPlayedState => {
	switch (action.type) {
		case RecentlyPlayedActionTypes.GET_RECENTLY_PLAYED_STARTED:
			return { ...state }
		case RecentlyPlayedActionTypes.GET_RECENTLY_PLAYED_SUCCESS:
			return { ...state, recentlyPlayedGameItems: action.payload.recentlyPlayedGameItems }
		case RecentlyPlayedActionTypes.GET_RECENTLY_PLAYED_FAILURE:
			return { error: action.payload.error, recentlyPlayedGameItems: [] }
		case RecentlyPlayedActionTypes.UPDATE_RECENTLY_PLAYED_STARTED:
			return { ...state }
		case RecentlyPlayedActionTypes.UPDATE_RECENTLY_PLAYED_SUCCESS:
			return { ...state, recentlyPlayedGameItems: action.payload.recentlyPlayedGameItems }
		case RecentlyPlayedActionTypes.UPDATE_RECENTLY_PLAYED_FAILURE:
			return { error: action.payload.error, recentlyPlayedGameItems: [] }
		default:
			return state
	}
}
